import React from 'react';
import logo from './logo.svg';
import { PageLayout } from './components/Layout';
import { useHistory } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "./utils/NavigationClient";
import Login from './components/Login';
import { GlobalStateProvider } from "./utils/GlobalState";
import { useEffect } from 'react';

type AppProps = {
  pca: IPublicClientApplication
};

function App({ pca }: AppProps) {
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);
  pca.setNavigationClient(navigationClient);

  useEffect(() => {
    // Previous implementation listened for an 'incomingMeetingId' event and
    // forced navigation to /join. That behavior was intrusive and not
    // necessary — components that need the meetingId should react to the
    // storage or the event themselves. Remove the navigation listener so
    // the app doesn't automatically change route on auth restore.
    // If needed, components can add their own event listeners to react when
    // the meetingId is available.
    // NOTE: leaving this effect in place would have required history as a
    // dependency and caused automatic navigation; we intentionally keep the
    // App shell passive here.
  }, [history]);

  return (
    <GlobalStateProvider>
      <MsalProvider instance={pca}>
          <Login />
      </MsalProvider> 
    </GlobalStateProvider>      
  );
}

export default App;
